import api from '@api/api';
import authApi from '@api/authApi';
import CrudApi from '@api/crudApi';
import { PublicUser, type User } from '@models/user';
import service from '@util/service';

export default service(
  'userApi',
  class UserApi extends CrudApi<PublicUser, User> {
    path = 'v1/users';
    model = PublicUser;

    async create(user: User) {
      user.email ??= { address: user.userName };
      return await super.create(user);
    }

    override async update(user: Partial<User> & { id: string }) {
      const updatedUser = await super.update(user);
      const me = await authApi.me.get();

      if (me?.user.id === updatedUser.id) {
        authApi.me.invalidate();
      }

      return updatedUser;
    }

    async changeEmail(email: string) {
      await api.post(`${this.path}/email`, { json: email });
      this.caches.invalidateAll();
    }

    async resendEmail(email: string) {
      await api.post(`${this.path}/email/resend/${encodeURIComponent(email)}`);
      this.caches.invalidateAll();
    }
  },
);
